export enum SampleEnum {
  REQUESTED = "REQUESTED",
  REJECTED = "REJECTED",
  VERIFIED = "VERIFIED",
  INITIALIZED = "INITIALIZED",
}
